import { JoinGameRequest, JoinGameResponse } from '../shared/functionTypes';
import useFirebaseFunctionAsync from './useFirebaseFunctionAsync';

const useJoinGameAsync = () =>
  useFirebaseFunctionAsync<JoinGameRequest, JoinGameResponse>('joinGame');

export default useJoinGameAsync;
